var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.027 9.03267C11.747 9.30601 11.587 9.69934 11.627 10.1193C11.687 10.8393 12.347 11.366 13.067 11.366H14.3337V12.1593C14.3337 13.5393 13.207 14.666 11.827 14.666H5.087C5.29366 14.4927 5.47366 14.2793 5.61366 14.0393C5.86032 13.6393 6.00033 13.166 6.00033 12.666C6.00033 11.1927 4.80699 9.99935 3.33366 9.99935C2.70699 9.99935 2.12699 10.2194 1.66699 10.586V7.67269C1.66699 6.29269 2.79366 5.16602 4.17366 5.16602H11.827C13.207 5.16602 14.3337 6.29269 14.3337 7.67269V8.63269H12.987C12.6137 8.63269 12.2737 8.77934 12.027 9.03267Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 8.27288V5.22625C1.66699 4.43291 2.15366 3.72622 2.89366 3.44622L8.18699 1.44622C9.01366 1.13289 9.90033 1.74624 9.90033 2.6329V5.16623",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0395 9.31376V10.6871C15.0395 11.0538 14.7462 11.3538 14.3729 11.3671H13.0662C12.3462 11.3671 11.6862 10.8404 11.6262 10.1204C11.5862 9.70044 11.7462 9.30711 12.0262 9.03377C12.2729 8.78044 12.6129 8.63379 12.9862 8.63379H14.3729C14.7462 8.64712 15.0395 8.94709 15.0395 9.31376Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 8H9.33366",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 12.6667C6.00033 13.1667 5.86032 13.64 5.61366 14.04C5.47366 14.28 5.29366 14.4933 5.087 14.6667C4.62033 15.0867 4.00699 15.3333 3.33366 15.3333C2.36033 15.3333 1.51366 14.8133 1.05366 14.04C0.806993 13.64 0.666992 13.1667 0.666992 12.6667C0.666992 11.8267 1.05366 11.0733 1.66699 10.5867C2.12699 10.22 2.70699 10 3.33366 10C4.80699 10 6.00033 11.1933 6.00033 12.6667Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29492 12.666L2.95492 13.326L4.37492 12.0127",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.0e14ab4c6c409504b61e447e19fb051a.svg";
export { ForwardRef as ReactComponent };